import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { BannerInfo, MyAreaNote, OptBannerInfo } from '@msc-b2c/interfaces/types';
import { MyAreaNotificationsState } from '@msc-b2c/interfaces/interfaces';

const initialState: MyAreaNotificationsState = {
  excursionsEmptyNote: undefined,
  obsEmptyNote: undefined,
  negativeBalanceNote: undefined,
  showZeroResultsNote: false,
  showNoResult: false,
  optExcursionBanner: undefined,
  showNegativeBalanceNote: undefined,
};

const myAreaNotificationsSlice = createSlice({
  name: 'myAreaNotifications',
  initialState,
  reducers: {
    excursionsEmptyNoteRetrieved(state, action: PayloadAction<MyAreaNote>) {
      state.excursionsEmptyNote = action.payload;
    },
    obsEmptyNoteRetrieved(state, action: PayloadAction<MyAreaNote>) {
      state.obsEmptyNote = action.payload;
    },
    triggerShowEmptyNote(state, action: PayloadAction<boolean>) {
      state.showZeroResultsNote = action.payload;
    },
    triggerShowNoResult(state, action: PayloadAction<boolean>) {
      state.showNoResult = action.payload;
    },
    optExcursionBannerRetrive(state, action: PayloadAction<OptBannerInfo>) {
      state.optExcursionBanner = action.payload;
    },
    negativeBalanceNoteRetrieved(state, action: PayloadAction<BannerInfo>) {
      state.negativeBalanceNote = action.payload;
    },
    triggerShowNegativeBalance(state, action: PayloadAction<boolean>) {
      state.showNegativeBalanceNote = action.payload;
    },
  },
});

export const {
  excursionsEmptyNoteRetrieved,
  obsEmptyNoteRetrieved,
  negativeBalanceNoteRetrieved,
  triggerShowEmptyNote,
  triggerShowNoResult,
  optExcursionBannerRetrive,
  triggerShowNegativeBalance,
} = myAreaNotificationsSlice.actions;
export default myAreaNotificationsSlice.reducer;
